import { SHOW_LOGOUT_MODAL, HIDE_LOGOUT_MODAL } from "./types";

export const showLogoutModal = () => ({
	type: SHOW_LOGOUT_MODAL,
});

export const hideLogoutModal = () => ({
	type: HIDE_LOGOUT_MODAL,
});
